













import { defineComponent, onMounted, ref, onUnmounted, useRoute } from '@nuxtjs/composition-api'
import usePDPAnalytics from '@/composables/analytics/usePDPAnalytics'

import Skeleton from '~/components/global/skeletons/Skeleton.vue'

export default defineComponent({
  components: { Skeleton },
  props: {
    mediumImg: {
      type: String,
      required: true,
    },
  },
  emits: ['cardClick'],
  setup(props) {
    const { trackCitationClick } = usePDPAnalytics()
    const route = useRoute()
    const url = route.value.path.toString()
    const isLoading = ref(false)
    const citationsImageURL = ref('')
    let debounceTimeout: ReturnType<typeof setTimeout> | null = null

    // .. Handling of image render only when it comes to screen
    onMounted(() => {
      isLoading.value = true
      debounceTimeout = setTimeout(() => {
        citationsImageURL.value = props.mediumImg
        isLoading.value = false
      }, 0)
    })

    // .. Handling of image render only when it comes to screen
    onUnmounted(() => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout)
      }
    })

    return { isLoading, citationsImageURL, trackCitationClick, url }
  },
})
